<template>
  <div class="saas-section">
    <div v-if="block.title" class="saas-section__title">
      <h2 class="saas-striped-title">{{ block.title }}</h2>
    </div>
    <div v-if="block.text" class="saas-section__description">
      {{ block.text }}
    </div>
    <div class="page-screenshot-steps">
      <div
        v-for="(step, index) in block.steps"
        :key="index"
        class="page-screenshot-steps__step"
        :class="{ 'page-screenshot-steps__step--reversed': index % 2 }"
      >
        <div class="page-screenshot-steps__step-image">
          <img
            v-if="step.screenshot"
            :src="step.screenshot.image.src"
            :alt="step.screenshot.title"
            :srcset="`${step.retina_screenshot.image.src} 2x`"
            class="page-screenshot-steps__step-image-img"
          />
        </div>
        <div class="page-screenshot-steps__step-content">
          <div class="page-screenshot-steps__step-inner">
            <div class="page-screenshot-steps__step-step">
              Step {{ index + 1 }}
            </div>
            <h3 class="page-screenshot-steps__step-title">{{ step.title }}</h3>
            <div
              class="page-screenshot-steps__step-text"
              v-html="getFormattedText(step.text)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="saas-section__actions">
      <CmsLink
        v-for="button in block.buttons"
        :key="button.id"
        :url-or-path="button.url_or_path"
        :class="`button button--${button.type} button--large`"
      >
        {{ button.text }}
      </CmsLink>
    </div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'

import CmsLink from '@saas/components/cms/CmsLink'

export default {
  name: 'PageBlockScreenshotSteps',
  components: { CmsLink },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getFormattedText(text) {
      const md = MarkdownIt({ html: false, breaks: false })
      return md.renderInline(text)
    },
  },
}
</script>
